import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule }
	from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

interface CommentModel {
	value: string;
}

@Component({
	selector: 'copo-dialog-save-comment',
	templateUrl: './dialog-save-comment.component.html',
	styleUrl: './dialog-save-comment.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [

		MatButtonModule,
		MatIconModule,

		MatDialogModule,
		TranslateModule,

		MatFormFieldModule,

		MatInputModule,
		TextFieldModule,
		FormsModule
	]
})
export class DialogSaveCommentComponent implements OnInit {
	comment;
	constructor(

		@Inject(MAT_DIALOG_DATA) public data: CommentModel,

		private readonly dialogRef: MatDialogRef<DialogSaveCommentComponent>
	) {
		this.comment = this.data.value;
	}

	ngOnInit() {
		this.dialogRef.updateSize('60%');
	}

	close() {
		this.dialogRef.close(this.data.value);
	}

	save() {
		this.dialogRef.close(this.comment);
	}
}
